import { Suspense, useEffect, useState } from 'react';
import { useSearchParams } from '@/lib/navigation';
import Navbar from '@/components/help-center/Navbar';
import Footer from '@/components/help-center/Footer';
import PowersPageHero from '@/components/help-center/powers/PowersPageHero';
import PowersCategories from '@/components/help-center/powers/PowersCategories';
import PowersCategoryInfo from '@/components/help-center/powers/PowersCategoryInfo';
import PowersCatalog from '@/components/help-center/powers/PowersCatalog';
import { isPowerCategory, type PowerCategory } from '@/lib/powers-data';
import { PowersListingSkeleton } from '@/components/help-center/PublicPageSkeleton';
import { useCatalogPowers } from '@/components/painel/powers/powers-cms-context';

function PowersPageContent() {
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState<PowerCategory>('todos');
  const { hydrated } = useCatalogPowers();

  useEffect(() => {
    const category = searchParams.get('category');
    if (category && isPowerCategory(category) && category !== 'todos') {
      setActiveCategory(category);
    }
  }, [searchParams]);

  if (!hydrated) {
    return (
      <div className="flex min-h-screen flex-col bg-gray-50">
        <Navbar />
        <main className="flex-1">
          <PowersListingSkeleton />
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1">
        <PowersPageHero searchQuery={searchQuery} onSearch={setSearchQuery} />
        <PowersCategories activeCategory={activeCategory} onCategoryChange={setActiveCategory} />
        <PowersCategoryInfo activeCategory={activeCategory} />
        <div>
          <PowersCatalog
            searchQuery={searchQuery}
            activeCategory={activeCategory}
            onCategoryChange={setActiveCategory}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}

function PowersPageFallback() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <Navbar />
      <main className="flex-1">
        <PowersListingSkeleton />
      </main>
      <Footer />
    </div>
  );
}

export default function PowersPage() {
  return (
    <Suspense fallback={<PowersPageFallback />}>
      <PowersPageContent />
    </Suspense>
  );
}
